<template>
  <div>
    <el-dialog title="保密协议" :visible.sync="jcxy" :close-on-click-modal="false" width="400px" center>
      <el-form :inline="true">
        <el-row>
          <el-form-item label="服务者">
            <el-select v-model="reqCreate.personId" @change="selectPerson" filterable clearable collapse-tags>
              <el-option v-for="(item, key) in singList" :key="key" :label="item.workerName"
                         :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10" hidden>
            <el-form-item label="姓名">
              <el-input v-model="reqCreate.name" show-word-limit clearable placeholder></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="身份证号码">
              <el-input v-model="reqCreate.idCard" maxlength="18" show-word-limit clearable style="width:233px"
                        placeholder></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10" hidden>
            <el-form-item label="手机号码">
              <el-input v-model="reqCreate.worker_tel" maxlength="18" show-word-limit clearable
                        placeholder></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="关联合同编号">
              <el-input v-model="reqCreate.relationContractNo" show-word-limit placeholder style="width: 250px"
                        clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="合同日期" prop="data1">
              <el-date-picker v-model="reqCreate.qsrq" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                              format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>


      </el-form>
      <span slot="footer" class="dialog-footer">
                <el-button @click="jcxy=false">取消</el-button>
                <el-button type="primary" @click="yulan()">预览合同</el-button>
            </span>
    </el-dialog>

    <el-dialog title="合同生成预览" :visible.sync="PDFVisible" :close-on-click-modal="false" width="900px" center>
      <iframe name="ifram11" :src="contractUrl" scrolling="auto" frameborder="0"
              style="width:870px;height:800px"></iframe>

      <span slot="footer" class="dialog-footer">
                <el-button @click="PDFVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendContractBtn">发送合同</el-button>
            </span>
    </el-dialog>

  </div>
</template>
<script>
import contract from '@/script/api/contractapi';
import globalData from "@/components/common/globaldata/global.data";

export default {
  data() {
    return {
      id: null,
      jcxy: false,
      singList: [],
      PDFVisible: false,
      contractUrl: null,
      reqCreate: {
        personId: null,
        idCard: null,
        workerNo:null,
        name: null,
        relationContractNo: null,
        tempSignData: {},
        contractFileId: null,
        templateNo: null,
        contractNo: null,
        contractType: null,
        worker_tel: null,
        cityId:null,
      }
    };
  },
  methods: {
    loadSingList() {
      contract.$ajaxContractGetBjContract({fraId:293}).then((res) => {
        if (res.data.errno == 0) {
          this.singList = res.data.data;
        }
      });
    },
    showDetail() {
      this.jcxy = true;
      this.reqCreate = {
        idCard: null,
        relationContractNo: null,
        tempSignData: {},
        workerNo:null,
        cityId:null,
        creditCode: null
      };
      this.loadSingList();
    },

    selectPerson(id) {
      if (id == null || id == '') {
        this.reqCreate.name = '';
        this.reqCreate.tel = '';
        this.reqCreate.idCard = '';
        this.reqCreate.cityId='';
        this.reqCreate.creditCode='';
      }
      let that = this;
      this.singList.forEach((e) => {
        if (e.id == id) {
          that.choosePerson = e;
        }
      });
      if (id != null) {
         this.reqCreate.workerNo = this.choosePerson.workerNo;
        this.reqCreate.name = this.choosePerson.workerName;
        this.reqCreate.tel = this.choosePerson.workerTel;
        this.reqCreate.idCard = this.choosePerson.idCard;
        this.reqCreate.relationContractNo = this.choosePerson.relationContractNo;
        this.reqCreate.cityId = this.choosePerson.cityId;
        this.reqCreate.creditCode = this.choosePerson.creditCode;
      }
    },
    checkFm() {
      if (this.reqCreate.idCard == null || this.reqCreate.idCard == '' || this.reqCreate.idCard.length != 18) {
        this.$message.error('请输入身份证号码');
        return false;
      }
      if (!this.checkIDCard(this.reqCreate.idCard)) {
        this.$message.error("请输入正确的身份证号码");
        return false;
      }
      if (this.reqCreate.relationContractNo == null || this.reqCreate.relationContractNo == '') {
        this.$message.error('请输入关联合同编号');
        return false;
      }
      if (this.reqCreate.qsrq == null || this.reqCreate.qsrq == '') {
        this.$message.error('请选择合同日期');
        return false;
      }
      return true;
    },
    fillTemplate() {
      return {
        name: this.reqCreate.name,
        // namecode: '',
        idcard: this.reqCreate.idCard,
        code: this.reqCreate.relationContractNo,
        yeah: this.reqCreate.qsrq.substring(0, 4) * 1,
        month: this.reqCreate.qsrq.substring(5, 7) * 1,
        day: this.reqCreate.qsrq.substring(8, 10) * 1,

      };
    },
    yulan() {
      if (!this.checkFm()) {
        return;
      }
      let temFields = this.fillTemplate();
      this.reqCreate.tempSignData = temFields;

      let reqData = {
        cityId: this.reqCreate.cityId,
        fraId : this.choosePerson.fraId,//globalData.franchisee.id,
        eventType: 108,
        name: '保密协议',
        simpleFormFields: temFields,
        creditCode: this.reqCreate.creditCode
      };

      const loading = this.$loading({
        lock: true,
        text: '努力生成中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });

      contract
          .$ajaxPreviewFile(reqData)
          .then((res) => {
            if (res.data.errno === 0) {
              loading.close();
              this.contractUrl = res.data.data.downloadUrl;
              this.reqCreate.templateNo = res.data.data.templateNo; //模板编号
               this.reqCreate.contractNo = res.data.data.contractNo; //合同编号
              this.reqCreate.contractFileId = res.data.data.fileId; //合同文件文件id
              this.PDFVisible = true;
            } else {
              loading.close();
              this.$message({
                showClose: true,
                message: res.data.data,
                type: 'warning',
                duration: 8000
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    sendContractBtn() {
      const loading = this.$loading({
        lock: true,
        text: '发送合同中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)'
      });
      this.reqCreate.fraId = globalData.franchisee.id;
      this.reqCreate.operId = globalData.userInfo.id;
      this.reqCreate.operName = globalData.userInfo.userName;
      this.reqCreate.contractType = 108;
      // this.reqCreate.tel=18550658899; // for test
      delete this.reqCreate.worker_tel;
      contract.$ajaxSignBaoMiAndResign(this.reqCreate).then((res) => {
        loading.close();
        if (res.data.errno == 0) {
          this.$message.success('合同发送成功！');
          // this.querySearch();
          this.$emit('querySearch');
          this.PDFVisible = false;
          this.jcxy = false;
        } else {
          this.$message.warning(res.data.data);
        }
      });
    },
    checkIDCard(idcode) {
      let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      let check_code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
      var code = idcode + "";
      var last = idcode[17];//最后一位
      var seventeen = code.substring(0, 17);
      var arr = seventeen.split("");
      var len = arr.length;
      var num = 0;
      for (var i = 0; i < len; i++) {
        num = num + arr[i] * weight_factor[i];
      }
      var resisue = num % 11;
      var last_no = check_code[resisue];
      var idcard_patter = /^[1-9]\d{5}(19\d{2}|20[0|1]\d)(0[1-9]|1[012])(0[1-9]|[1|2]\d|3[0|1])\d{3}(\d|X|x)$/;
      var format = idcard_patter.test(idcode);

      return last === last_no && format;
    }
  }
};
</script>
<style lang="">
</style>
